module.exports = __webpack_public_path__ + "static/media/logo_awardsforall_v2.9fcc6c91.png";